import {
    CREATE_DESPATCH_DC_FAILURE,
    CREATE_DESPATCH_DC_REQUEST,
    CREATE_DESPATCH_DC_SUCCESS,
    CREATE_USER_FORM_DESPATCH_DC,
    FETCH_SINGLE_DESPATCH_DC_FAILURE,
    FETCH_SINGLE_DESPATCH_DC_REQUEST,
    FETCH_SINGLE_DESPATCH_DC_SUCCESS,
    FETCH_DESPATCH_DC_FAILURE,
    FETCH_DESPATCH_DC_REQUEST,
    FETCH_DESPATCH_DC_SUCCESS,
    NAVIGATE_DESPATCH_DC_DETAILS,
    NAVIGATE_DESPATCH_DC,
    DESPATCH_DC_USERFORM_RESET,
    UPDATE_DESPATCH_DC_FAILURE,
    UPDATE_DESPATCH_DC_REQUEST,
    UPDATE_DESPATCH_DC_SUCCESS,
    DELETE_DESPATCH_DC_REQUEST,
    DELETE_DESPATCH_DC_SUCCESS,
    DELETE_DESPATCH_DC_FAILURE,
    DESPATCH_DC_USERFORM_NAVIGATE_TO_DETAIL_TAB,
    DESPATCH_DC_USERFORM_NAVIGATE_TO_DETAIL_REVERSE,
    FETCH_YARN_PO_IN_DESPATCH_DC_REQUEST,
    FETCH_YARN_PO_IN_DESPATCH_DC_SUCCESS,
    FETCH_YARN_PO_IN_DESPATCH_DC_FAILURE,
    FETCH_DESPATCH_DC_INVOICE_REQUEST,
    FETCH_DESPATCH_DC_INVOICE_SUCCESS,
    FETCH_DESPATCH_DC_INVOICE_FAILURE,
    RESET_DESPATCH_DC_INVOICE,
    HEADER_SEARCH_CALL_ONLOAD,
    SET_UNIT_NAME_DESPATCH_DC,
    FETCH_DESPATCH_PO_IN_DESPATCH_DC_SUCCESS
} from './despatchDC.actionsType';

// 1
export const DESPATCH_DC = 'despatchDC';

let initialState = {
    loading: false,
    despatchDC: [],
    yarnPOInDespatchDC: [],
    despatchDCInvoice: [],
    supplierListBasedOnProgram: [],

    userform: {
        fldFKDeliveryAt: '',
        fldFKClientID: '',
        fldIsInHouseDelivery: false,
        fldGrandGrossValue: 0,
        fldOtherPlusValue: 0,
        fldOtherMinusValue: 0,
        FldIsGenerateStyleWise: false,
        startDate: new Date().setDate(new Date().getDate() - 15),
        endDate: new Date(),
        unitId: 1,
    },

    // userform: {
    //     fldFKDeliveryAt: '',
    //     fldFKClientID: '',
    //     fldIsInHouseDelivery: false,

    //     fldFKSaleOrder: [],
    //     fldFKStyle: [],
    //     fldFKSaleOrder2: [],
    //     fldGrossValue: 0,
    //     fldDiscountValue: 0,
    //     fldIGSTValue: 0,
    //     fldSGSTValue: 0,
    //     fldCGSTValue: 0,
    //     fldCGSTPercentage: 0,
    //     fldIGSTPercentage: 0,
    //     fldSGSTPercentage: 0,
    //     fldDiscountPercentage: 0,
    //     fldGrandGrossValue: 0,
    //     fldOtherPlusValue: 0,
    //     fldOtherMinusValue: 0,
    //     fldRoundoff: 0,
    //     fldTransportCharges: 0,
    //     fldClearingCharges: 0,
    //     fldInsurance: 0,
    //     fldLoadandUnload: 0,
    //     fldWOGTransportCharges: 0,
    //     fldWOGClearingCharges: 0,
    //     fldWOGInsurance: 0,
    //     fldWOGLoadandUnload: 0,
    //     fldWOGOtherPlusValue: 0,
    //     fldWOGOtherMinusValue: 0,
    //     fldTaxableValue: 0,
    //     fldTotalValue: 0,
    //     fldGrandTotalValue: 0
    // },
    selectedTeam: {},
    detailsId: '',
    activeKey: 1,
    unitId: 1,
    isDespatchDC: false,
    despatchDCSelectedValue: null,
    errorMessage: '',
    iperrorMessage: '',
    headerSearchCall: true,
};

export let despatchDCReducer = (state = initialState, action) => {
    let { type, payload, updatePayload } = action;
    switch (type) {
        case FETCH_DESPATCH_DC_REQUEST:
        case FETCH_YARN_PO_IN_DESPATCH_DC_REQUEST:
        case CREATE_DESPATCH_DC_REQUEST:
        case FETCH_DESPATCH_DC_INVOICE_REQUEST:
        case FETCH_SINGLE_DESPATCH_DC_REQUEST:
        case UPDATE_DESPATCH_DC_REQUEST:
        case DELETE_DESPATCH_DC_REQUEST:
            return {
                ...state,
                loading: true
            };
        case FETCH_DESPATCH_DC_SUCCESS:
            return {
                ...state,
                loading: false,
                despatchDC: updatePayload
            };

        case HEADER_SEARCH_CALL_ONLOAD:
            return {
                ...state,
                loading: false,
                headerSearchCall: payload
            }

        case FETCH_DESPATCH_DC_INVOICE_SUCCESS:
            return {
                ...state,
                loading: false,
                despatchDCInvoice: updatePayload
            };
        case FETCH_YARN_PO_IN_DESPATCH_DC_SUCCESS:
            return {
                ...state,
                loading: false,
                yarnPOInDespatchDC: updatePayload?.PONO
            };
        case CREATE_DESPATCH_DC_SUCCESS:
            return {
                ...state,
                loading: false,
                // userform: {
                //     fldFKDeliveryAt: '',
                //     fldFKClientID: '',
                //     fldIsInHouseDelivery: false,

                //     fldFKSaleOrder: [],
                //     fldFKStyle: [],
                //     fldFKSaleOrder2: [],
                //     fldGrossValue: 0,
                //     fldDiscountValue: 0,
                //     fldIGSTValue: 0,
                //     fldSGSTValue: 0,
                //     fldCGSTValue: 0,
                //     fldCGSTPercentage: 0,
                //     fldIGSTPercentage: 0,
                //     fldSGSTPercentage: 0,
                //     fldDiscountPercentage: 0,
                //     fldGrandGrossValue: 0,
                //     fldOtherPlusValue: 0,
                //     fldOtherMinusValue: 0,
                //     fldRoundoff: 0,
                //     fldTransportCharges: 0,
                //     fldClearingCharges: 0,
                //     fldInsurance: 0,
                //     fldLoadandUnload: 0,
                //     fldWOGTransportCharges: 0,
                //     fldWOGClearingCharges: 0,
                //     fldWOGInsurance: 0,
                //     fldWOGLoadandUnload: 0,
                //     fldWOGOtherPlusValue: 0,
                //     fldWOGOtherMinusValue: 0,
                //     fldTaxableValue: 0,
                //     fldTotalValue: 0,
                //     fldGrandTotalValue: 0
                // },

                userform: {
                    fldFKDeliveryAt: '',
                    fldFKClientID: '',
                    fldIsInHouseDelivery: false,
                    fldGrandGrossValue: 0,
                    fldOtherPlusValue: 0,
                    fldOtherMinusValue: 0,
                    startDate: state.userform.startDate,
                    endDate: state.userform.endDate,
                    unitId: state.userform.unitId
                },
                detailsId: updatePayload
            };
        case FETCH_SINGLE_DESPATCH_DC_SUCCESS:
            return {
                ...state,
                loading: false,
                selectedTeam: updatePayload,
                userform: {
                    ...updatePayload, startDate: state.userform.startDate,
                    endDate: state.userform.endDate,
                    unitId: state.userform.unitId
                }

            };
        case UPDATE_DESPATCH_DC_SUCCESS:
            return {
                ...state,
                loading: false,
                // userform: {
                //     fldFKDeliveryAt: '',
                //     fldFKClientID: '',
                //     fldIsInHouseDelivery: false,

                //     fldFKSaleOrder: [],
                //     fldFKStyle: [],
                //     fldFKSaleOrder2: [],
                //     fldGrossValue: 0,
                //     fldDiscountValue: 0,
                //     fldIGSTValue: 0,
                //     fldSGSTValue: 0,
                //     fldCGSTValue: 0,
                //     fldCGSTPercentage: 0,
                //     fldIGSTPercentage: 0,
                //     fldSGSTPercentage: 0,
                //     fldDiscountPercentage: 0,
                //     fldGrandGrossValue: 0,
                //     fldOtherPlusValue: 0,
                //     fldOtherMinusValue: 0,
                //     fldRoundoff: 0,
                //     fldTransportCharges: 0,
                //     fldClearingCharges: 0,
                //     fldInsurance: 0,
                //     fldLoadandUnload: 0,
                //     fldWOGTransportCharges: 0,
                //     fldWOGClearingCharges: 0,
                //     fldWOGInsurance: 0,
                //     fldWOGLoadandUnload: 0,
                //     fldWOGOtherPlusValue: 0,
                //     fldWOGOtherMinusValue: 0,
                //     fldTaxableValue: 0,
                //     fldTotalValue: 0,
                //     fldGrandTotalValue: 0
                // },

                userform: {
                    fldFKDeliveryAt: '',
                    fldFKClientID: '',
                    fldIsInHouseDelivery: false,
                    fldGrandGrossValue: 0,
                    fldOtherPlusValue: 0,
                    fldOtherMinusValue: 0,
                    FldIsGenerateStyleWise: false,
                    startDate: state.userform.startDate,
                    endDate: state.userform.endDate,
                    unitId: state.userform.unitId
                },
                detailsId: ''
            };
        case DELETE_DESPATCH_DC_SUCCESS:
            return {
                ...state,
                loading: false,
                // userform: {
                //     fldFKDeliveryAt: '',
                //     fldFKClientID: '',
                //     fldIsInHouseDelivery: false,

                //     fldFKSaleOrder: [],
                //     fldFKStyle: [],
                //     fldFKSaleOrder2: [],
                //     fldGrossValue: 0,
                //     fldDiscountValue: 0,
                //     fldIGSTValue: 0,
                //     fldSGSTValue: 0,
                //     fldCGSTValue: 0,
                //     fldCGSTPercentage: 0,
                //     fldIGSTPercentage: 0,
                //     fldSGSTPercentage: 0,
                //     fldDiscountPercentage: 0,
                //     fldGrandGrossValue: 0,
                //     fldOtherPlusValue: 0,
                //     fldOtherMinusValue: 0,
                //     fldRoundoff: 0,
                //     fldTransportCharges: 0,
                //     fldClearingCharges: 0,
                //     fldInsurance: 0,
                //     fldLoadandUnload: 0,
                //     fldWOGTransportCharges: 0,
                //     fldWOGClearingCharges: 0,
                //     fldWOGInsurance: 0,
                //     fldWOGLoadandUnload: 0,
                //     fldWOGOtherPlusValue: 0,
                //     fldWOGOtherMinusValue: 0,
                //     fldTaxableValue: 0,
                //     fldTotalValue: 0,
                //     fldGrandTotalValue: 0
                // },

                userform: {
                    fldFKDeliveryAt: '',
                    fldFKClientID: '',
                    fldIsInHouseDelivery: false,
                    fldGrandGrossValue: 0,
                    fldOtherPlusValue: 0,
                    fldOtherMinusValue: 0,
                    startDate: state.userform.startDate,
                    endDate: state.userform.endDate,
                    unitId: state.userform.unitId
                },

                detailsId: ''
            };
        case FETCH_DESPATCH_DC_FAILURE:
        case FETCH_YARN_PO_IN_DESPATCH_DC_FAILURE:
        case FETCH_SINGLE_DESPATCH_DC_FAILURE:
        case CREATE_DESPATCH_DC_FAILURE:
        case UPDATE_DESPATCH_DC_FAILURE:
        case DELETE_DESPATCH_DC_FAILURE:
        case FETCH_DESPATCH_DC_INVOICE_FAILURE:
            return {
                ...state,
                loading: false,
                errorMessage: updatePayload
            };
        case CREATE_USER_FORM_DESPATCH_DC:
            return {
                ...state,
                loading: false,
                userform: {
                    ...state.userform,
                    [payload.key]: payload.value
                }
            };
        case DESPATCH_DC_USERFORM_RESET:
            return {
                ...state,
                // userform: {
                //     fldFKDeliveryAt: '',
                //     fldFKClientID: '',
                //     fldIsInHouseDelivery: false,

                //     fldFKSaleOrder: [],
                //     fldFKStyle: [],
                //     fldFKSaleOrder2: [],
                //     fldGrossValue: 0,
                //     fldDiscountValue: 0,
                //     fldIGSTValue: 0,
                //     fldSGSTValue: 0,
                //     fldCGSTValue: 0,
                //     fldCGSTPercentage: 0,
                //     fldIGSTPercentage: 0,
                //     fldSGSTPercentage: 0,
                //     fldDiscountPercentage: 0,
                //     fldGrandGrossValue: 0,
                //     fldOtherPlusValue: 0,
                //     fldOtherMinusValue: 0,
                //     fldRoundoff: 0,
                //     fldTransportCharges: 0,
                //     fldClearingCharges: 0,
                //     fldInsurance: 0,
                //     fldLoadandUnload: 0,
                //     fldWOGTransportCharges: 0,
                //     fldWOGClearingCharges: 0,
                //     fldWOGInsurance: 0,
                //     fldWOGLoadandUnload: 0,
                //     fldWOGOtherPlusValue: 0,
                //     fldWOGOtherMinusValue: 0,
                //     fldTaxableValue: 0,
                //     fldTotalValue: 0,
                //     fldGrandTotalValue: 0
                // },
                userform: {
                    fldFKDeliveryAt: '',
                    fldFKClientID: '',
                    fldIsInHouseDelivery: false,
                    fldGrandGrossValue: 0,
                    fldOtherPlusValue: 0,
                    fldOtherMinusValue: 0,
                    FldIsGenerateStyleWise: false,
                    startDate: state.userform.startDate,
                    endDate: state.userform.endDate,
                    unitId: state.userform.unitId
                },
                detailsId: '',
                activeKey: 1
            };
        case NAVIGATE_DESPATCH_DC_DETAILS:
            return {
                ...state,
                isDespatchDC: true,
                despatchDCSelectedValue: updatePayload.despatchDCSelectedValue
            };
        case NAVIGATE_DESPATCH_DC:
            return {
                ...state,
                isDespatchDC: false
            };
        case RESET_DESPATCH_DC_INVOICE:
            return {
                ...state,
                despatchDCInvoice: []
            };
        case DESPATCH_DC_USERFORM_NAVIGATE_TO_DETAIL_TAB:
            return {
                ...state,
                // userform: {
                //     fldFKDeliveryAt: '',
                //     fldFKClientID: '',
                //     fldIsInHouseDelivery: false,

                //     fldFKSaleOrder: [],
                //     fldFKStyle: [],
                //     fldFKSaleOrder2: [],
                //     fldGrossValue: 0,
                //     fldDiscountValue: 0,
                //     fldIGSTValue: 0,
                //     fldSGSTValue: 0,
                //     fldCGSTValue: 0,
                //     fldCGSTPercentage: 0,
                //     fldIGSTPercentage: 0,
                //     fldSGSTPercentage: 0,
                //     fldDiscountPercentage: 0,
                //     fldGrandGrossValue: 0,
                //     fldOtherPlusValue: 0,
                //     fldOtherMinusValue: 0,
                //     fldRoundoff: 0,
                //     fldTransportCharges: 0,
                //     fldClearingCharges: 0,
                //     fldInsurance: 0,
                //     fldLoadandUnload: 0,
                //     fldWOGTransportCharges: 0,
                //     fldWOGClearingCharges: 0,
                //     fldWOGInsurance: 0,
                //     fldWOGLoadandUnload: 0,
                //     fldWOGOtherPlusValue: 0,
                //     fldWOGOtherMinusValue: 0,
                //     fldTaxableValue: 0,
                //     fldTotalValue: 0,
                //     fldGrandTotalValue: 0
                // },
                // ,
                userform: {
                    fldFKDeliveryAt: '',
                    fldFKClientID: '',
                    fldIsInHouseDelivery: false,
                    fldGrandGrossValue: 0,
                    fldOtherPlusValue: 0,
                    fldOtherMinusValue: 0,
                    FldIsGenerateStyleWise: false,
                    startDate: state.userform.startDate,
                    endDate: state.userform.endDate,
                    unitId: state.userform.unitId
                },
                activeKey: 2
            };

        case FETCH_DESPATCH_PO_IN_DESPATCH_DC_SUCCESS:
            return {
                ...state,
                supplierList: updatePayload
            }
        case DESPATCH_DC_USERFORM_NAVIGATE_TO_DETAIL_REVERSE:
            return {
                ...state,
                // userform: {
                //     fldFKDeliveryAt: '',
                //     fldFKClientID: '',
                //     fldIsInHouseDelivery: false,

                //     fldFKSaleOrder: [],
                //     fldFKStyle: [],
                //     fldFKSaleOrder2: [],
                //     fldGrossValue: 0,
                //     fldDiscountValue: 0,
                //     fldIGSTValue: 0,
                //     fldSGSTValue: 0,
                //     fldCGSTValue: 0,
                //     fldCGSTPercentage: 0,
                //     fldIGSTPercentage: 0,
                //     fldSGSTPercentage: 0,
                //     fldDiscountPercentage: 0,
                //     fldGrandGrossValue: 0,
                //     fldOtherPlusValue: 0,
                //     fldOtherMinusValue: 0,
                //     fldRoundoff: 0,
                //     fldTransportCharges: 0,
                //     fldClearingCharges: 0,
                //     fldInsurance: 0,
                //     fldLoadandUnload: 0,
                //     fldWOGTransportCharges: 0,
                //     fldWOGClearingCharges: 0,
                //     fldWOGInsurance: 0,
                //     fldWOGLoadandUnload: 0,
                //     fldWOGOtherPlusValue: 0,
                //     fldWOGOtherMinusValue: 0,
                //     fldTaxableValue: 0,
                //     fldTotalValue: 0,
                //     fldGrandTotalValue: 0
                // },
                userform: {
                    fldFKDeliveryAt: '',
                    fldFKClientID: '',
                    fldIsInHouseDelivery: false,
                    fldGrandGrossValue: 0,
                    fldOtherPlusValue: 0,
                    fldOtherMinusValue: 0,
                    startDate: state.userform.startDate,
                    endDate: state.userform.endDate,
                    unitId: state.userform.unitId
                },
                activeKey: 1
            };
        case SET_UNIT_NAME_DESPATCH_DC:
            return {
                ...state,
                unitId: payload
            };
        default:
            return state;
    }
};
